import { isInStorybook } from "./isInStorybook"
import type { Coordinates } from "./location"

type GetStaticMapFunc = (options: {
  latitude: number
  longitude: number
  zoom: number
  width: number
  height: number
  key: string
  language?: string
  format?: "png8" | "png" | "png32" | "gif" | "jpg" | "jpg-baseline"
  maptype?: "roadmap" | "satellite" | "terrain" | "hybrid"
  scale?: 1 | 2
  markers?: Coordinates[]
  markersIcon?: string
  markersScale?: 1 | 2 | 4
  mapId?: string
}) => string

const getStaticMap: GetStaticMapFunc = ({
  latitude,
  longitude,
  zoom,
  width,
  height,
  key,
  markers = [],
  markersIcon = "https://ucarecdn.com/27dce7e2-a614-4265-ae9f-c830f35028ee/LuggageStorePin.png",
  markersScale = 2,
  language = "en",
  format = "png",
  maptype = "roadmap",
  mapId = "1d1c94a365ccdcca",
  scale = 2,
}) => {
  if (isInStorybook()) {
    return `https://placehold.co/${width}x${height}/png?text=Google%20Map`
  }

  const baseUrl = `https://maps.googleapis.com/maps/api/staticmap?language=${language}&size=${width}x${height}&zoom=${zoom}&scale=${scale}&center=${latitude},${longitude}&maptype=${maptype}&format=${format}&key=${key}&map_id=${mapId}`

  const markersCoordinates = markers.map(({ latitude, longitude }) => `${latitude},${longitude}`).join("|")
  if (markersCoordinates) {
    return `${baseUrl}&markers=icon:${markersIcon}|scale:${markersScale}|${markersCoordinates}`
  }
  return baseUrl
}

export { getStaticMap }
